import React from 'react';
import Icon from 'shared/components/icon';

interface Props {
  header: string;
  description: string;
  portfolioItemType: string;
  onClick: () => void;
  className?: string;
}

const EmptyPlaceholder = ({header, description, portfolioItemType, onClick, className}: Props) => (
  <button
    className={`portfolio-empty-placeholder prefix-flex prefix-align-items ${className}`}
    onClick={onClick}
    data-segment-track="button"
    data-button-name={`portfolio ${portfolioItemType} empty-placeholder`}
  >
    <div className="prefix-flex-grow-1">
      <p className="portfolio-empty-placeholder-header">{header}</p>
      <p className="portfolio-empty-placeholder-paragraph">{description}</p>
    </div>
    <Icon className="portfolio-empty-placeholder-icon" iconType="plus" />
  </button>
);

export default EmptyPlaceholder;
